module.exports = __webpack_public_path__ + "static/media/general-scheme.39d6cf25.png";